import { motion } from "framer-motion";

// Reusable scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Masked line-by-line text reveal
export const MaskedLines = ({ lines, className = "", lineClassName = "", stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: 0.2 + i * stagger, ease: [0.16, 1, 0.3, 1] }}
          className={`block ${lineClassName}`}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
